import request from 'superagent';
import tree from '../state';
import config from '../config';

export function getLostKeyComboModel(country) {
    return request.get(`${config.apiBase}/api/support/lost-key-combo/${country}`)
        .set('authorization', tree.get('token'))
        .then(res => JSON.parse(res.text));
}

export function getSupportVideos(tag) {
    return request.get(`${config.apiBase}/api/support/videos`)
        .set('authorization', tree.get('token'))
        .then(res => JSON.parse(res.text));
}


// WEBPACK FOOTER //
// ./src/services/supportService.js